import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { companyInfo } from '@/mocks/companyData';

export default function Privacy() {
  const lastModified = '2025年4月1日';

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-medium tracking-[0.15em] text-primary-600 bg-primary-100/70 px-4 py-1.5 rounded-full mb-6">
              PRIVACY POLICY
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-6 tracking-wide">
              プライバシーポリシー
            </h1>
            <p className="text-sm text-foreground-500">
              最終更新日：{lastModified}
            </p>
          </div>
        </div>
      </section>

      {/* Policy Points */}
      <section className="py-12 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-50 rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5">
                <i className="ri-database-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">情報の収集</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                適切かつ公正な手段で個人情報を収集します。
              </p>
            </div>
            <div className="bg-background-50 rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5">
                <i className="ri-focus-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">利用目的</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                明示した目的の範囲内でのみ個人情報を利用します。
              </p>
            </div>
            <div className="bg-background-50 rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">第三者提供</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                法令に基づく場合を除き、第三者に提供しません。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Full Policy Text */}
      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <article className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-8">

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">1. 個人情報の定義</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本プライバシーポリシーにおいて「個人情報」とは、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別できるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）をいいます。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">2. 個人情報の収集方法</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、お客様がお問い合わせやサービス利用登録をする際に、氏名、会社名、メールアドレス、電話番号などの個人情報をお尋ねすることがあります。また、お客様と当社の取引に関する情報を、当社の提携先などから収集することがあります。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">3. 個人情報の利用目的</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  当社がお客様からお預かりした個人情報を利用する目的は以下の通りです。
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="text-sm text-foreground-600 leading-relaxed">当社サービスの提供・運営のため</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">お客様からのお問い合わせに回答するため</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">新サービスやキャンペーン等のご案内を送付するため</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">メンテナンスや重要なお知らせなど必要に応じたご連絡のため</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">利用規約に違反したお客様のご利用を停止するため</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">サービスの改善・新サービス開発のための分析</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">4. 個人情報の安全管理</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。個人情報への不正アクセス、個人情報の紛失、破壊、改ざん、漏洩などの防止に努め、適切な安全対策を実施します。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">5. 個人情報の第三者提供</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、次に掲げる場合を除き、あらかじめお客様の同意を得ることなく第三者に個人情報を提供することはありません。法令に基づく場合、人の生命・身体・財産の保護に必要な場合、公衆衛生・児童の健全育成に特に必要な場合、国の機関や地方公共団体の事務に協力する必要がある場合。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">6. 個人情報の開示・訂正・削除</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  お客様からご自身の個人情報の開示、訂正、追加、削除、利用停止のご依頼があった場合、ご本人様であることを確認した上で、法令に従い速やかに対応いたします。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">7. プライバシーポリシーの変更</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、必要に応じて本ポリシーの内容を変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">8. お問い合わせ窓口</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
                </p>
                <div className="mt-3 text-sm text-foreground-600 leading-relaxed space-y-1">
                  <p>{companyInfo.name}</p>
                  <p>所在地：{companyInfo.address}</p>
                  <p>E-mail：<a href={`mailto:${companyInfo.email}`} className="text-primary-600 hover:text-primary-700 underline">{companyInfo.email}</a></p>
                </div>
              </div>

            </article>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}